import { createFileRoute } from '@tanstack/react-router';
import { AreaLanding } from '@/components';

export const Route = createFileRoute('/_layout/view/$areaSlug/')({
  component: AreaLanding
});
